import React from 'react';
import { useSurveyContext } from '../contexts/SurveyContext';
import { getPrimaryColor } from '../utils/surveyHelpers';

export const ProgressBar = () => {
  const { survey, currentQuestion, questionIndex } = useSurveyContext();

  if (!survey) return null;

  const primaryColor = getPrimaryColor(survey);
  const total = survey.questions.length;

  return (
    <div className="progress-wrapper">
      <p className="progress-label">Question {questionIndex + 1} of {total}</p>
      <div className="progress">
        {survey.questions.map((q) => (
          <div
            key={q.id}
            className="bar"
            style={{
              background: currentQuestion?.id === q.id ? primaryColor : '#e0e0e0',
            }}
          />
        ))}
      </div>
    </div>
  );
};